import { ChatPage } from "@/features/chat/ChatPage";
import { buildHost } from "@/features/chat/chatHost";

/** `/build/with-ai` (new build chat) and `/build/with-ai/:sessionUuid`: the chat, hosted in Build. */
export function BuildWithAiPage() {
  return <ChatPage host={buildHost} />;
}
